// Test IDs central registry
export const IDS = {
  nav: {
    root: "nav-root",
    logo: "nav-logo",
    link: (slug) => `nav-link-${slug}`,
    cta: "nav-cta",
  },
  hero: {
    root: "hero-root",
    ctaGuides: "hero-cta-guides",
    ctaGadget: "hero-cta-gadget",
  },
  manifesto: "manifesto-root",
  marquee: "marquee-root",
  categories: {
    root: "categories-root",
    chip: (slug) => `category-chip-${slug}`,
  },
  guides: {
    grid: "guides-grid",
    card: (slug) => `guide-card-${slug}`,
    link: (slug) => `guide-link-${slug}`,
  },
  gadget: {
    grid: "gadget-grid",
    card: (slug) => `gadget-card-${slug}`,
    link: (slug) => `gadget-link-${slug}`,
    filter: (slug) => `gadget-filter-${slug}`,
    priceFilter: (range) => `gadget-price-${range}`,
    affiliate: (slug) => `gadget-affiliate-${slug}`,
  },
  bundle: {
    root: (slug) => `bundle-${slug}`,
    affiliate: (slug, i) => `bundle-affiliate-${slug}-${i}`,
    total: (slug) => `bundle-total-${slug}`,
  },
  footer: {
    root: "footer-root",
    disclosure: "footer-disclosure",
  },
};
